import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map } from 'immutable';

import { Card } from '../helpers/Card';

import style from './style.module.css';

const MailingSummaryComponent = ({ header: headerProp, isEmail, showPm = false, children }) => {
  const header = headerProp || Map();

  return (
    <Card className={style.host} title="Mailing Info">
      {showPm && (
        <>
          <div>
            <span className="field-label">PM</span>
            {header.get('pmFLName')}
          </div>
          <div>
            <span className="field-label">Date Mailed</span>
            {header.get('date')}
          </div>
        </>
      )}
      <div>
        <span className="field-label">Module</span>
        {header.get('recordOwnerUserName')}
        <br />
        {header.get('recordSubOwnerUserName')}
      </div>
      <div>
        <span className="field-label">Buyer</span>
        {header.get('buyerLegalName')}
        <br />
        {header.get('projectCategory')} ({header.get('projectHarvcoLeadUserName')})
      </div>
      <div>
        <span className="field-label">Activity</span>
        <i className={isEmail ? 'fa fa-folder-o' : 'fa fa-envelope-o'} /> {header.get('activity')}
      </div>
      {children}
    </Card>
  );
};

MailingSummaryComponent.propTypes = {
  children: PropTypes.node,
  header: PropTypes.instanceOf(Map),
  isEmail: PropTypes.bool,
  showPm: PropTypes.bool,
};

/** Mailing header card: PM, mailing date, module, buyer and activity of a mailing. */
export const MailingSummary = memo(MailingSummaryComponent);
